define('models/Podio.Models.Contact',['require','lib/backbone/Backbone.PodioModel','lib/Podio.Config'],function(require) {

  var PodioModel = require('lib/backbone/Backbone.PodioModel');
  var Config = require('lib/Podio.Config');

  var ContactModel = PodioModel.extend({

    initialize: function() {
      this.useDirectAPIAccess = true;
    },

    urlAPI: function() {
      return '/contact/user/{0}'.format(this.get('profile_id'));
    }

  }, {
    getOwn: function() {
      return new ContactModel({
        id: Config.user.profile_id,
        user_id: Config.user.user_id,
        name: Config.user.name,
        image: Config.user.avatar ? {
          thumbnail_link: Config.user.avatar
        } : null
      });
    }
  });

  return ContactModel;

});

